module.exports = __webpack_public_path__ + "img/businessValuationResults.e66dcf81.png";